import {
  DialogRoot,
  DialogPortal,
  DialogBackdrop,
  DialogPopup,
  DialogHeader,
  DialogTitle,
  DialogContent,
  DialogCloseButton,
} from '../ui/dialog';
import {
  InvestmentAssetForm,
  type InvestmentAssetFormData,
} from '../forms/investment-asset-form';
import type { InvestmentAsset } from '../../types';

export interface InvestmentAssetDialogProps {
  open: boolean;
  editing: InvestmentAsset | null;
  existingAssets: InvestmentAsset[];
  onSubmit: (data: InvestmentAssetFormData) => void;
  onClose: () => void;
}

export function InvestmentAssetDialog({
  open,
  editing,
  existingAssets,
  onSubmit,
  onClose,
}: InvestmentAssetDialogProps) {
  return (
    <DialogRoot
      open={open}
      onOpenChange={(isOpen) => {
        if (!isOpen) onClose();
      }}
    >
      <DialogPortal>
        <DialogBackdrop className="z-40" />
        <DialogPopup className="z-41">
          <DialogHeader>
            <DialogTitle>{editing ? 'Editar papel' : 'Novo papel'}</DialogTitle>
            <DialogCloseButton />
          </DialogHeader>
          <DialogContent>
            <InvestmentAssetForm
              onSubmit={onSubmit}
              onClose={onClose}
              initialData={editing}
              existingAssets={existingAssets}
            />
          </DialogContent>
        </DialogPopup>
      </DialogPortal>
    </DialogRoot>
  );
}
